import { Select, SelectOption } from "@clockwise/design-system";
import { InfoOutlined } from "@clockwise/design-system/icons";
import { Tooltip } from "@material-ui/core";
import { range } from "lodash";
import React from "react";
import {
  FOCUS_TIME_IDEAL_MINUTES_DEFAULT,
  FOCUS_TIME_RANGE_MAX,
  FOCUS_TIME_RANGE_MIN,
} from "../../../smart-hold-sync";

type Props = {
  /**
   * In minutes
   */
  threshold?: number;
  disabled?: boolean;
  onChange: (minutes: number) => void;
  tooltip?: boolean;
};

export function ThresholdLabel({
  threshold = FOCUS_TIME_IDEAL_MINUTES_DEFAULT,
  disabled,
  onChange,
  tooltip = false,
}: Props) {
  const hours = Math.floor(threshold / 60);
  const tooltipText = `Clockwise will try to schedule around ${hours} hours of Focus Time per week at times that are convenient for you. You can manage your Focus Time preferences in Settings.`;
  return (
    <div className="cw-flex cw-items-center cw-gap-2 cw-flex-wrap md:cw-flex-nowrap">
      Schedule up to
      <Select
        disabled={disabled}
        name="focusTimeThreshold"
        value={threshold}
        onChange={onChange}
        size="large"
      >
        {range(FOCUS_TIME_RANGE_MIN, FOCUS_TIME_RANGE_MAX).map((hours) => {
          return (
            <SelectOption value={hours * 60} key={hours}>
              {hours} hrs
            </SelectOption>
          );
        })}
      </Select>
      Focus Time/week
      {tooltip && (
        <Tooltip placement="top" title={tooltipText} classes={{ popper: "cw-max-w-[168px]" }}>
          <InfoOutlined className="cw-h-4 cw-w-4 cw-text-muted" />
        </Tooltip>
      )}
    </div>
  );
}
